module.exports = __webpack_public_path__ + "resources/img/logo_footer_nhn_m.937c590ffae91ffcc37fdc30ffc272e2.png";